export default {
  type: 'Umbrella',
  sections: [
    { id: 'umbrella1', title: 'Umbrella Insurance Overview' },
    { id: 'understand', title: 'Understanding Umbrella Insurance' },
    { id: 'umbrella2', title: 'Main Price Impacting Factors' },
    { id: 'umbrella3', title: 'Bundle and Save' }
  ],
  introData: {
    title: 'Understanding Umbrella Insurance',
    paragraphs: [
      "While you may have various insurance policies in place to protect your home, car, and other assets, sometimes these policies may not be enough to cover the costs of a major incident or lawsuit. That's where umbrella insurance comes in.",
      "This type of insurance provides an extra layer of liability coverage that can help protect you and your assets from the unexpected. In this guide, we'll cover the basics of umbrella insurance, what it covers, and how to determine if it's right for you."
    ]
  },
  bestRateTips: [
    "Bundle with home and auto: Most insurers require you to have your home and auto insurance with them to qualify for umbrella coverage, and will offer discounts for bundling.",
    "Increase your base liability limits: Raising the liability limits on your home and auto policies can sometimes be more cost-effective than purchasing a separate umbrella policy.",
    "Maintain a clean record: Keep a claims-free record and good credit score to qualify for lower umbrella insurance rates.",
    "Choose a higher deductible: Selecting a higher deductible can lower your premium costs, but ensure you can afford the out-of-pocket expense if needed.",
    "Review coverage annually: As your assets and lifestyle change, regularly review your umbrella coverage to ensure you're adequately protected."
  ],
  briefGuide: "Umbrella insurance is an extra layer of liability coverage that kicks in after your other insurance policies have reached their coverage limits. It can provide coverage for legal fees, medical expenses, and other costs associated with a liability claim.",
  coverageItems: [
    "What is umbrella insurance and how does it work?",
    "What does umbrella insurance typically cover?",
    "How much umbrella insurance coverage do you need?",
    "What is not covered by umbrella insurance?",
    "How to obtain umbrella insurance and what to consider when choosing a policy."
  ],
  additionalInfo: {
    overview: "Umbrella insurance is a type of insurance policy that provides additional liability coverage beyond your other insurance policies. It's important to have umbrella insurance coverage to protect your assets and financial future in the event of a costly lawsuit or other unexpected event.",
    sections: [
      {
        title: "Types of claims covered by umbrella insurance",
        paragraphs: [
          "Bodily injury claims resulting from a car accident or other accident.",
          "Property damage claims resulting from damage to someone else's property.",
          "Personal injury claims resulting from libel, slander, or other types of defamation.",
          "Lawsuits resulting from incidents that occur on your property, such as a slip and fall."
        ]
      },
      {
        title: "Benefits of having umbrella insurance coverage",
        paragraphs: [
          "Increased protection for your assets: Umbrella insurance can provide additional coverage beyond your other insurance policies.",
          "Peace of mind: Knowing that you have extra liability coverage can give you peace of mind and reduce your stress level.",
          "Cost savings: Having umbrella insurance coverage can potentially save you money on your other insurance policies by reducing the likelihood of a claim exceeding your coverage limits."
        ]
      }
    ]
  },
  pricingFactors: {
    title: "Main Price Impacting Factors for Umbrella Insurance",
    description: "When comparing rates and coverages for Umbrella insurance, it is important to keep in mind data points that Insurance Companies find most important when evaluating your rate.",
    factors: [
      {
        title: "Liability Coverage Limits",
        description: "The amount of liability coverage you choose to purchase for your umbrella insurance policy can have a significant impact on the price of your policy. Higher liability coverage limits will typically result in higher premiums since it means that the insurance company is taking on more risk.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Prior Claims",
        description: "If you have made previous claims on your insurance policies, including your auto, home, or other liability insurance, this can impact the price of your umbrella insurance. Insurance companies may view individuals who have made claims as being more likely to make future claims.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Personal Information",
        description: "Your personal information, such as your age, marital status, and credit score, can also impact the price of your umbrella insurance. Insurance companies may use this information to determine your level of risk.",
        imageUrl: "/images/productPageImages/credit.png"
      },
      {
        title: "Occupation",
        description: "Your occupation can also impact the price of your umbrella insurance. Certain occupations, such as those that involve more physical labor or those that are considered high-risk, may result in higher premiums.",
        imageUrl: "/images/productPageImages/marital.png"
      }
    ]
  },
  relatedProducts: [
    {
      title: "Home Insurance",
      imageUrl: "/images/product-type-icons/homeInsurance.svg",
      link: "/products/homeinsurance"
    },
    {
      title: "Auto Insurance",
      imageUrl: "/images/product-type-icons/autoInsurance.svg",
      link: "/products/autoinsurance"
    },
    {
      title: "Flood Insurance",
      imageUrl: "/images/product-type-icons/floodInsurance.svg",
      link: "/floodinsurance"
    }
  ],
  ctaText: "(Auto, Life, Flood, etc.)"
}; 